export default __webpack_public_path__ + "static/media/gallery_01.1bb66ca9.jpg";